import SerchList from "../components/serch/SerchList";

const SerchPage = () => {
  return <SerchList />;
};

export default SerchPage;
